import styled from 'styled-components';
import * as M from '../Message/Styled';

export const Label = styled.div`
  position: relative;
  width: 68px;
  height: 68px;
  background: var(--red25);
  border: 1px solid #f4b9ac;
  border-radius: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 6px;
  margin-bottom: 8px;

  @media (max-width: 767px) {
    width: 28px;
    height: 28px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Icon = styled.div`
  font-size: 22px;
  line-height: 1em;
  color: var(--carbone120);
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

export const Text = styled.div`
  font-size: 10px;
  line-height: 1.1em;
  font-weight: 600;
  color: var(--carbone120);
  padding: 0 5px;
  text-align: center;
  display: flex;
  align-items: center;
  top: -2px;
  position: relative;
  min-width: 68px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const ExtLabel = styled(Label)`
  &:hover {
    ${M.Message} {
      display: block;
    }
  }
`;
